<template>
  <div :disabled="disabled" ref="editor-wrapper" @dragover.stop @drop.stop>
    <div ref="editor"></div>
    <div class="emoji-mart-wrapper" v-show="emojiMartOpened" v-if="hasEmojis">
      <picker set="twitter" @select="addEmoji" title="Pick your emoji…" emoji="point_up" @onClick="addEmoji" ref="emoji-picker" />
    </div>
  </div>
</template>

<script>
import { Picker } from 'emoji-mart-vue'
import emojiData from 'emoji-mart-vue/data/twitter.json';
import Quill from '../../../plugins/quill/dist/quill.js';

export default {
  name: "quill",
  components: {
    Picker,
  },
  props: {
    value: {},
    uploadHander: {
      type: Function,
      required: false
    },
    mentionSearchFunction: {
      type: Function,
      required: false
    },
    allowImages: {
      type: Boolean,
      default: false
    },
    allowDragAndDrop: {
      type: Boolean,
      default: false
    },
    showToolbar: {
      type: Boolean,
      default: false
    },
    enterIsSend: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    hasEmojis: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      editor: null,
      changed: false,
      updating: false,
      emojiMartOpened: false
    }
  },
  watch: {
    disabled(val) {
      this.editor.enable(!val)
    }
  },
  mounted () {
    let that = this;

    let quillSettings = {
      theme: 'bubble',
      bounds: this.$refs["editor-wrapper"],
      modules: {
        uploader: false,
        keyboard: {
          bindings: {}
        },
        toolbar: this.showToolbar
      }
    };

    if(this.enterIsSend) {
      quillSettings.modules.keyboard.bindings["enter"] = {
        key: 'Enter',
        shiftKey: false,
        handler: () => {
          if(!this.emojiMartOpened) {
            this.$emit("keydown", {
              key: 'Enter',
              shiftKey: false
            })
          } else {
            $(this.$refs["emoji-picker"].$el).find(".emoji-mart-emoji").first().trigger("click");
          }
        }
      }
    }

    if(this.allowImages){
      quillSettings.modules.imageResize = {}
    }

    if(this.allowDragAndDrop){
      quillSettings.modules.imageDropAndPaste = {
        handler: this.handleImageDropAndPaste
      }
    }

    if(this.mentionSearchFunction != undefined) {
      quillSettings.modules.mention = {
        allowedChars: /^[A-Za-z\sÅÄÖåäö]*$/,
        mentionDenotationChars: ["@"],
        source: this.mentionSearchFunction,
        defaultMenuOrientation: 'bottom',
        renderItem: (item) => {
          let icon = "fa fa-user";

          switch(item.type){
            case "project":
              icon = "icon-briefcase";
              break;
            case "task":
              icon = "fa fa-tasks";
              break;
            case "user":
              icon = "fa fa-user-o";
              break;
          }

          return `<span class="d-flex"><span class="mr-2"><i class="${icon}"></i></span><span>${item.value}</span><span>`
        },
        dataAttributes: ["id", "value", "color", "denotationChar", "link", "target", "disabled", "type"],
        selectKeys: ['Enter']
      }
    }

    this.editor = new Quill(this.$refs.editor, quillSettings)

    this.editor.setContents([])
    this.editor.clipboard.dangerouslyPasteHTML(0, this.value);

    this.editor.on("text-change", (e) => {
      that.changed = true;
      that.$emit("input", that.editor.root.innerHTML)

      if(this.hasEmojis){
        let emojiSelection = this.getCurrentEmojiRange();

        if(emojiSelection.isEmojiSearch) {
          this.$refs["emoji-picker"].$refs["search"].value = emojiSelection.search
        }
      }
    });

    this.editor.root.addEventListener("blur", () => {
      if(that.changed){
        that.$emit("change", that.editor.root.innerHTML);
        that.changed = false;
      }
    })
    
    this.changed = false;
  },
  methods: {
    addEmoji(emoji) {
      this.editor.focus()
      emoji.sheet_x = emojiData.emojis[emoji.id].k[0];
      emoji.sheet_y = emojiData.emojis[emoji.id].k[1];

      let emojiSelection = this.getCurrentEmojiRange();
      if(emojiSelection.isEmojiSearch){
        this.editor.deleteText(emojiSelection.index, emojiSelection.length, Quill.sources.USER);
      }
      
      let range = this.editor.getSelection();

      this.editor.insertEmbed(range.index, 'emoji', emoji, Quill.sources.USER);
      this.editor.insertText(range.index + 1, " ", Quill.sources.USER);
      this.editor.setSelection(range.index + 2, 1, Quill.sources.USER);

      this.emojiMartOpened = false;
    },
    openEmoji() {
      this.emojiMartOpened = !this.emojiMartOpened;
      if(this.emojiMartOpened){
        this.$nextTick(() => {
          $(this.$refs["emoji-picker"].$el).find(".emoji-mart-search input").focus()
        })
      }
    },
    getCurrentEmojiRange() {
      let range = this.editor.getSelection();
      let ix = range.index;

      let emojiSearch = "";
      let isEmojiSearch = false;

      for(let c = ix-1; c >= 0; c--) {
        let char = this.editor.getText(c, 1);
        if(char == ' ') break;
        else if(char == ':'){
          isEmojiSearch = true;
          this.emojiMartOpened = true;
          break;
        } else {
          emojiSearch = char + emojiSearch;
        }
      }

      return {
        index: ix - emojiSearch.length - 1,
        length: emojiSearch.length + 1,
        search: emojiSearch,
        isEmojiSearch: isEmojiSearch
      }
    },
    update() {
      this.editor.setContents([])
      this.editor.clipboard.dangerouslyPasteHTML(0, this.value);
      this.changed = false;
    },
    async handleImageDropAndPaste(imageDataUrl, type, imageData, file) {
      let quill = this.editor;

      let finalUrl = imageDataUrl;

      if(file.kind == ""){
        file = imageData.toFile("upload.png");
      }

      if(this.uploadHander !== undefined){
        finalUrl = await this.uploadHander(file);
      }

      if(finalUrl != null){
        let index = (quill.getSelection() || {}).index;
        if (index === undefined || index < 0) index = quill.getLength();
        quill.insertEmbed(index, 'image', finalUrl, 'user')
      }
    },
    clear() {
      this.editor.setContents([])
    },
    getAsPlainText() {
      let result = "";
      let contents = this.editor.getContents();
      for (const op of contents.ops) {
        if(op.insert.mention !== undefined){
          let type = op.insert.mention.type;
          let id = op.insert.mention.id;
          result += `<${type}:${id}> `;
        } else if(op.insert.emoji !== undefined){
          let emoji = op.insert.emoji;
          result += `<emoji:${emoji}> `;
        } else {
          result += `${op.insert} `;
        }
      }
      return result.trim();
    },
    focus() {
      this.$nextTick(() => {
        this.editor.focus();
      })
    }
  },
}
</script>

<style lang="css">
@import '~quill/dist/quill.bubble.css';
@import '../../../plugins/quill-mention/src/quill.mention.scss';

.form-control[disabled] {
  background-color: #ccc;
}

.textarea-emoji-control {
  display: none;
}

.emoji-mart-wrapper {
  position: absolute;
  top: -427px;
  left: 0;
}
</style>